import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { ScrollArea } from "@/components/ui/scroll-area";
import { PrivacyContent } from "./PrivacyContent";

interface PrivacyDialogProps {
  trigger: React.ReactNode;
}

export function PrivacyDialog({ trigger }: PrivacyDialogProps) {
  return (
    <Dialog>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent className="max-w-2xl max-h-[80vh]">
        <DialogHeader>
          <DialogTitle>Privacy Policy</DialogTitle>
        </DialogHeader>
        <ScrollArea className="h-[60vh] pr-4">
          <PrivacyContent />
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
}
